import * as React from "react"
import ChartIndicator from "./indicators/ChartIndicator"
import SingleValueIndicator from "./indicators/SingleValueIndicator"
import { IIndicator } from "../index"

type Props = IIndicator

export const Indicator = (props: Props): JSX.Element =>
    props.hasChart ? (
        <ChartIndicator {...props} />
    ) : (
        <SingleValueIndicator {...props} />
    )

export default Indicator
